const HeaderBottom = () => {
  return (
    <div className="headerBottom">
      <span className="spHeB spHeBPink">About</span>
      <span className="spHeB">Jobs</span>
    </div>
  );
};

export default HeaderBottom;
